module.exports = __webpack_public_path__ + "static/img/wpp1_2.bca358f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/wpp1_2.png
// module id = 2sdy
// module chunks = 2